import { ACTIONS_LICENSE_JOURNAL } from '../_constants/licenseJournal.constants';

const initialState = {
  byId: {},
};

export function licenseJournalReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_LICENSE_JOURNAL.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_LICENSE_JOURNAL.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_LICENSE_JOURNAL.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default licenseJournalReducer;
